// extracted by mini-css-extract-plugin
module.exports = {"coverLetter":"CoverLetterStyles_coverLetter__2JfUZ","title":"CoverLetterStyles_title__DiYi7","pageTitle":"CoverLetterStyles_pageTitle__13Rg5"};